import React, { memo } from "react";
import { Link } from "../../utils/link";

const BreadCrumb = ({ page, pageHandle, subPage, bg }) => {
  const marginBottom = bg === "white" ? "mb-5 lg:mb-5" : "mb-[150px] lg:mb-5";
  return (
    <nav
      className={`rounded-md w-full tracking-wide leading-6 ${
        bg === "white" ? "text-black/60" : "text-white"
      } ${marginBottom}`}
    >
      <ol className="flex">
        <li>
          <Link to="/" className={`no-underline hover:text-secondary-500`}>
            Home
          </Link>
        </li>
        {page && (
          <li>
            <span className="pl-[6px] pr-[5px]">/</span>
          </li>
        )}
        {page && (
          <li>
            <Link
              to={pageHandle}
              className={`no-underline hover:text-secondary-500`}
            >
              {page}
            </Link>
          </li>
        )}
        {subPage && (
          <>
            <li>
              <span className="pl-[6px] pr-[5px]">/</span>
            </li>
            <li
                className={`no-underline ${
                    bg === "white" ? "text-black/60" : "text-white/80"
                }`}
            >
              {subPage}
            </li>
          </>
        )}
      </ol>
    </nav>
  );
};

export default memo(BreadCrumb);
